// src/app/layouts/main-layout/main-layout.component.ts


import {Component, DestroyRef, OnInit, ChangeDetectionStrategy, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AppMenuComponent} from '../../@components/app-menu/app-menu.component';

import {Router, RouterOutlet} from '@angular/router';
import {NavigationService} from '../../../@commons/services/navigation.service';

@Component({
    selector: 'vw-main-layout',
    imports: [AppMenuComponent, RouterOutlet],
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class MainLayoutComponent implements OnInit {
  currentRoute: string = 'home';
  private readonly destroyRef = inject(DestroyRef);

  constructor(private router: Router, private navigationService: NavigationService) {}

  ngOnInit() {
    // NavigationService follows the router (and the menu) itself: remember the screen we leave when it changes
    this.navigationService.currentScreen$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(screen => {
      this.currentRoute = screen; // Update the current route based on the service
    });

    const storedScreen = this.navigationService.getStoredScreen();
    if (storedScreen) {
      this.navigationService.changeScreen(storedScreen);
    }
  }

  onScreenChange(screen: string) {
    this.navigationService.changeScreen(screen);
    this.router.navigate([screen]);
  }
}
